import * as React from 'react';
import useOption from 'components/customHooks';
import { Dropdown } from '@symphony-ui/uitoolkit-components';
import FixedRateEditor from './coupons/FixedRateEditor';
import FloatingRateEditor from './coupons/FloatingRateEditor';
import PopupContext from 'contexts/PopupContext';
import PopupButtons from './PopupButtons';
import Coupon from '../../../../..//models/data/Coupon';
const CouponPopup = ({ data, hasOverride, save }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const isOverridden = React.useMemo(() => data?.override?.coupons?.[0].fixedRate !== undefined || data?.override?.coupons?.[0].floatingRate !== undefined, [data?.override?.coupons]);
    const [interestBasis, setInterestBasis] = React.useState(data?.override?.coupons?.[0].interestBasis ?? data?.data?.coupons?.[0].interestBasis ?? 'FIXED');
    const [fixedRate, setFixedRate] = React.useState(isOverridden ? data?.override?.coupons?.[0].fixedRate : data?.data?.coupons?.[0].fixedRate);
    const [floatingRate, setFloatingRate] = React.useState(isOverridden ? data?.override?.coupons?.[0].floatingRate : data?.data?.coupons?.[0].floatingRate);
    const options = useOption('/syndicate/overview/interest-basis/options');
    const onChangeInterestBasis = React.useCallback((event) => {
        setInterestBasis(event.target.value.value);
        setFixedRate(undefined);
        setFloatingRate(undefined);
    }, []);
    const isFixed = React.useMemo(() => {
        return interestBasis?.startsWith('FIX');
    }, [interestBasis]);
    const onChangeFixedRate = React.useCallback((event) => {
        setFixedRate(event.target.value);
    }, []);
    const onChangeFloatingRate = React.useCallback((event) => {
        setFloatingRate(event.target.value);
    }, []);
    const coupon = React.useMemo(() => (new Coupon({ fixedRate, floatingRate, interestBasis })), [fixedRate, floatingRate, interestBasis]);
    return (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: '1rem' } },
            React.createElement(Dropdown, { onMenuClose: () => setBlockClose(false), onMenuOpen: () => setBlockClose(true), options: options, isInputClearable: true, onChange: onChangeInterestBasis, value: options.find(o => 'value' in o && o.value === interestBasis) })),
        React.createElement("div", { style: { marginBottom: '1rem' } }, isFixed ? React.createElement(FixedRateEditor, { value: fixedRate, onChange: onChangeFixedRate }) : React.createElement(FloatingRateEditor, { value: floatingRate, onChange: onChangeFloatingRate })),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { isDisabled: false, value: coupon, hasOverride: hasOverride, save: save }))));
};
export default CouponPopup;
